module.exports = __webpack_public_path__ + "videos/mts-products-chats-distribution-groups.3a04327.webm";